import React from "react";
import LibraryPdfItem from "@/react-components/LibraryPdfItem";
import TopScrollLink from "@/react-components/TopScrollLink";
import { api } from "@/utils/api";
import i18n from "i18next";

class IPO extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfMonthInfos: undefined,
      pdfYearInfos: undefined,
      pdfInfos: undefined,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    Promise.all([
      // IPO(月のPDFデータ)
      api.library.getIpoMonthList(),
      // IPO(年のPDFデータ)
      api.library.getIpoYearList(),
      // IPO(年月以外のPDFデータ)
      api.library.getIpoList(),
    ])
      .then((responseList) => {
        let pdfMonthInfos = responseList[0];
        if (pdfMonthInfos && pdfMonthInfos.length > 0) {
          pdfMonthInfos.sort((a, b) => b.belongYear - a.belongYear);
        }
        this.setState({
          pdfMonthInfos,
          pdfYearInfos: responseList[1],
          pdfInfos: responseList[2],
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  scrollTo = (itemid) => {
    if (itemid) {
      let anchorElement = document.getElementById(itemid);
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  };

  getCategoryList = () => {
    const { pdfMonthInfos, pdfYearInfos, pdfInfos } = this.state;
    const categoryList = [];
    if (pdfMonthInfos && pdfMonthInfos.length > 0) {
      categoryList.push({
        itemid: pdfMonthInfos[0]?.category?.itemid,
        categoryName: pdfMonthInfos[0]?.category?.categoryName,
      });
    }

    if (pdfYearInfos && pdfYearInfos.length > 0) {
      categoryList.push({
        itemid: pdfYearInfos[0]?.category?.itemid,
        categoryName: pdfYearInfos[0]?.category?.categoryName,
      });
    }

    if (pdfInfos && pdfInfos.length > 0) {
      categoryList.push({
        itemid: pdfInfos[0]?.category?.itemid,
        categoryName: pdfInfos[0]?.category?.categoryName,
      });
    }

    return categoryList;
  };

  getList = () => {
    const { pdfMonthInfos } = this.state;
    const newList = [];
    if (pdfMonthInfos && pdfMonthInfos.length > 0) {
      let belongYear = 0;
      let newSubList = [];
      for (const pdfInfo of pdfMonthInfos) {
        let belongYeartmp = pdfInfo.belongYear;
        if (belongYear !== belongYeartmp) {
          belongYear = belongYeartmp;
          newSubList = [];
          newSubList.push({
            id: pdfInfo.id,
            title: pdfInfo.title,
            updateDate: pdfInfo.updateDate,
            createDate: pdfInfo.createDate,
            pdfFile: pdfInfo.pdfFile,
          });
          newList.push({
            itemid: pdfInfo.itemid,
            infoTitle: belongYear,
            pdfList: newSubList,
          });
        } else {
          newSubList.push({
            id: pdfInfo.id,
            title: pdfInfo.title,
            updateDate: pdfInfo.updateDate,
            createDate: pdfInfo.createDate,
            pdfFile: pdfInfo.pdfFile,
          });
        }
      }
    }

    return newList;
  };

  render() {
    const { pdfMonthInfos, pdfYearInfos, pdfInfos } = this.state;

    const categoryList = this.getCategoryList();
    const newList = this.getList();

    return (
      <div className="library-container">
        <div className="summary-container summary-top-link-container">
          {categoryList && categoryList.length > 0
            ? categoryList.map((item, index) => (
                <TopScrollLink
                  key={index}
                  item={item}
                  scrollTo={() => this.scrollTo(item.itemid)}
                />
              ))
            : ""}
        </div>
        <div className="line-anchor-point"></div>

        <div className="library-container-info-area">
          {pdfMonthInfos && pdfMonthInfos.length > 0 ? (
            <div
              id={pdfMonthInfos[0]?.category?.itemid}
              className="library-container-info-title"
            >
              <div className="library-container-margin-bottom-16">
                {pdfMonthInfos[0]?.category?.categoryName}
              </div>
              <div className="library-container-info-sumarry">
                {i18n.t("TCLs0008_monthly_topics")}
              </div>
            </div>
          ) : (
            ""
          )}

          {newList && newList.length > 0
            ? newList.map((item, index) => (
                <div key={index}>
                  <div className="library-container-info-subtitle">
                    {item.infoTitle}
                    {i18n.t("TCLs0008_splicing_year")}
                  </div>
                  <div className="library-container-area library-container-area-three">
                    {item.pdfList && item.pdfList.length > 0
                      ? item.pdfList.map((subitem, subindex) => (
                          <LibraryPdfItem
                            splicingText={i18n.t("TCLs0008_splicing_month")}
                            key={subindex}
                            item={subitem}
                            classFlex="library-ipo-info-area"
                          />
                        ))
                      : ""}
                  </div>
                </div>
              ))
            : ""}
        </div>

        <div className="library-container-info-area">
          {pdfYearInfos && pdfYearInfos.length > 0 ? (
            <div
              id={pdfYearInfos[0]?.category?.itemid}
              className="library-container-info-title"
            >
              <div className="library-container-margin-bottom-16">
                {pdfYearInfos[0]?.category?.categoryName}
              </div>
              <div className="library-container-info-sumarry">
                {i18n.t("TCLs0008_years_data")}
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="library-container-area library-container-area-three">
            {pdfYearInfos && pdfYearInfos.length > 0
              ? pdfYearInfos.map((item, index) => (
                  <LibraryPdfItem
                    splicingText={i18n.t("TCLs0008_splicing_year")}
                    key={index}
                    item={item}
                    classFlex="library-ipo-info-area"
                  />
                ))
              : ""}
          </div>
        </div>

        <div className="library-container-info-area">
          {pdfInfos && pdfInfos.length > 0 ? (
            <div
              id={pdfInfos[0]?.category?.itemid}
              className="library-container-info-title"
            >
              <div className="library-container-margin-bottom-16">
                {pdfInfos[0]?.category?.categoryName}
              </div>
              <div className="library-container-info-sumarry">
                {i18n.t("TCLs0008_guidance_data")}
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="library-container-area library-container-col-area">
            {pdfInfos && pdfInfos.length > 0
              ? pdfInfos.map((item, index) => (
                  <LibraryPdfItem key={index} item={item} />
                ))
              : ""}
          </div>
        </div>
      </div>
    );
  }
}

export default IPO;
